import { RecipientOption } from 'hooks/useRecipientOptions'
import { Reply } from './replies_api'

/**
 * Default To for a plain reply: the latest inbound sender (`target`), falling
 * back to the lead's email when that is missing or is our own alias — so we
 * never default to replying to ourselves.
 */
export function resolveReplyToDefault(
  target: Reply | undefined,
  reply: Reply | undefined
): RecipientOption[] {
  if (!target) return []
  const self = reply?.sender_email_address?.toLowerCase()
  const fromEmail = target.from_email_address
  const isSelf = !fromEmail || fromEmail.toLowerCase() === self
  const email = isSelf ? (reply?.lead_email ?? '') : fromEmail
  if (!email) return []
  const name = isSelf ? '' : (target.from_name ?? '')
  return [{ label: name ? `${name} <${email}>` : email, value: email }]
}
